import { FormItemTypes, IDictionary } from '@bimser/core';
import { JSX } from 'react';
import { ICSSProperties } from '../../../../entities/common';
import PanelBase from '../../base/PanelBase';
import { IInputGroupProperties } from './entities/IInputGroupProperties';

export default class InputGroup extends PanelBase {
	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.InputGroup;
		this.headerMode = 'none';

		this.__calculatePadding = this.__calculatePadding.bind(this);
		this.__getPanelContainerStyles = this.__getPanelContainerStyles.bind(this);
	}

	/**
	 * @description Backend üzerinden padding değeri varsayılan olarak "10px 15px 10px 15px" geliyor.
	 * Bunun backend üzerinden iptal edilmesi demek projenin yeniden yayınlanması anlamına geliyor.
	 * Bu sebepten işlemi client üzerinde yapıyoruz.
	 */
	__calculatePadding() {
		if (this.style?.padding === '10px 15px 10px 15px') {
			return;
		}

		return this.style?.padding;
	}

	__getPanelContainerStyles(): ICSSProperties {
		return {
			...this.style,
			padding: this.__calculatePadding()
		};
	}

	__loadProperties(data: IInputGroupProperties) {
		super.__loadProperties(data);
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData()
		};
	}

	__render(children?: JSX.Element) {
		return super.__render();
	}
}
